/**
 * Vocabulario do acompanhamento da cotacao (P-COT-3), comum ao Follow up, a linha do
 * tempo e aos documentos pedidos. O servidor classifica; aqui ficam so as opcoes da
 * tela e a correspondencia entre a area da pendencia e o grupo da linha do tempo, a
 * mesma de `backend/internal/modules/operation/domain/timeline.go`.
 */
import { type PendingArea, type TimelineEntry } from '@/shared/api/resources';
import { type TimelineItem } from '@/shared/ui/Timeline';

/** Converte a entrada da linha do tempo da API no item do componente. */
export function itemDaLinhaDoTempo(evento: TimelineEntry): TimelineItem {
  return {
    id: evento.id,
    kind: evento.kind,
    summary: evento.summary,
    actorLabel: evento.actor_label,
    createdAt: evento.created_at,
    detail: evento.detail,
    situation: evento.situation,
    situationGroup: evento.situation_group,
    situationStatus: evento.situation_status,
    actorSide: evento.actor_side,
  };
}

/** Grupo da linha do tempo de cada area: documentos e operacional ficam na cotacao. */
export function grupoDaArea(area: PendingArea): string {
  return area === 'documentos' || area === 'operacional' ? 'cotacao' : area;
}

/** Origens do Follow up, na ordem do historico do OnPoint. */
export const origensDoFollowUp = [
  { value: '', label: 'Todas as origens' },
  { value: 'cotacao', label: 'Cotacao' },
  { value: 'cadastro', label: 'Cadastro' },
  { value: 'pep', label: 'PEP' },
  { value: 'credito', label: 'Credito' },
  { value: 'subscricao', label: 'Subscricao' },
  { value: 'resseguro', label: 'Resseguro' },
  { value: 'juridico', label: 'Juridico' },
  { value: 'comercial', label: 'Comercial' },
  { value: 'emissao', label: 'Emissao' },
  { value: 'nomeacao', label: 'Nomeacao' },
];

/** Areas que podem pedir o documento ao corretor, as mesmas da pendencia. */
export const areasQuePedem = [
  { value: 'cadastro', label: 'Cadastro' },
  { value: 'credito', label: 'Credito' },
  { value: 'pep', label: 'PEP' },
  { value: 'subscricao', label: 'Subscricao' },
  { value: 'resseguro', label: 'Resseguro' },
  { value: 'juridico', label: 'Juridico' },
  { value: 'comercial', label: 'Comercial' },
  { value: 'documentos', label: 'Documentos' },
  { value: 'operacional', label: 'Operacional' },
];
